import React, { FC, ReactNode, useState } from 'react';
import styled from '@emotion/styled';
import Button from '@app/components/Button';
import SVG from '@app/components/SVG';
import ChevronDownImage from '@app/images/chevronDown.svg';

interface Props {
  id: string;
  dataTestId?: string;
  header: ReactNode;
  children: ReactNode;
  className?: string;
}

// A plain toggle rather than the antd Collapse, whose close animation flashes the content for a frame under React 18
const ExpandableSection: FC<Props> = ({ id, dataTestId = id, header, children, className }) => {
  const [isExpanded, setIsExpanded] = useState<boolean>(false);

  return (
    <Main className={className}>
      <HeaderButton
        id={id}
        dataTestId={dataTestId}
        appearance='text'
        colorScheme='grey'
        cornerType='none'
        shadowType='none'
        aria-expanded={isExpanded}
        onClick={(): void => setIsExpanded(!isExpanded)}
      >
        <Chevron isExpanded={isExpanded}>
          <SVG image={ChevronDownImage} accessibilityLabel='' width={16} height={16} />
        </Chevron>
        {header}
      </HeaderButton>
      {isExpanded && <Content>{children}</Content>}
    </Main>
  );
};

export default ExpandableSection;

const Main = styled.div`
  border-block: 1px solid var(--gray-solid-200);
`;

const HeaderButton = styled(Button)`
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  padding: 12px 16px;
  text-align: start;
`;

const Chevron = styled.span<{ isExpanded: boolean }>`
  display: flex;
  transform: rotate(${(p): number => (p.isExpanded ? 0 : -90)}deg);
  transition: transform 0.2s;
`;

const Content = styled.div`
  border-top: 1px solid var(--gray-solid-200);
`;
